import Vue from 'vue';
import VueRouter from 'vue-router';

const Foo = {template: '<div>foo</div>'};
const Bar = {template: '<div>bar</div>'};
import Simulator from './components/Simulator.vue'
import Preview from './components/Preview.vue'
import Order from './components/simulator/Order.vue'
import OrderInput from './components/simulator/order/Input.vue'
import OrderConfirm from './components/simulator/order/Confirm.vue'
import OrderDone from './components/simulator/order/Done.vue'
import Letter from './components/simulator/product/item/Font.vue'
import OrderMenu from './components/simulator/product/OrderMenu.vue'
import Product from './components/simulator/Product.vue'
import Item from './components/simulator/product/Item.vue'
import Category from './components/simulator/product/item/Category.vue'
import Figure from './components/simulator/product/item/Figure.vue'
import Design from './components/simulator/product/item/Design.vue'
import Color from './components/simulator/product/item/Color.vue'
import Cart from './components/simulator/Cart.vue'
import Info from './components/simulator/Info.vue'
import How from './components/simulator/info/How.vue'
import Manual from './components/simulator/info/Manual.vue'
import FAQ from './components/simulator/info/FAQ.vue'
import Notice from './components/simulator/info/Notice.vue'
import AboutLimit from './components/simulator/info/AboutLimit.vue'
import Rule from './components/simulator/info/Rule.vue'
import Privacy from './components/simulator/info/Privacy.vue'
import Law from './components/simulator/info/Law.vue'

Vue.use(VueRouter);

const routes = [
  {path: '/', redirect: '/product/item/category'},
  {
    path: '/',
    component: Simulator,
    props: (route) => ({
      category_id: Number(route.params.category_id),
      figure_id: Number(route.params.figure_id),
      design_id: Number(route.params.design_id),
    }),
    children: [
      {path: 'product', component: Product, children: [
          {path: '', redirect: 'item/category'},
          {path: 'item', component: Item, children: [
              {path: 'category', name: 'category', component: Category},
              {path: ':category_id', name: 'product-figure', component: Figure},
              {path: ':category_id/figure/:figure_id', name: 'design', component: Design},
              {path: ':category_id/figure/:figure_id/design/:design_id', name: 'color', component: Color,},
              {path: ':category_id/figure/:figure_id/design/:design_id/font', name: 'font', component: Letter},
              {path: ':category_id/figure/:figure_id/design/:design_id/estimate', name: 'estimate', component: OrderMenu},
            ]},
        ]},
      {path: 'cart', component: Cart},

      {path: 'order/input', component: OrderInput, name: 'orderInput'},
      {path: 'order/confirm', component: OrderConfirm, name: 'orderConfirm'},
      {path: 'order/done', component: OrderDone, name: 'orderDone'},
      {path: '/order/:id', component: Order},
      {path: 'info', component: Info, children: [
          {path: 'how', name: 'how', component: How},
          {path: 'manual', name: 'manual', component: Manual},
          {path: 'faq', name: 'faq', component: FAQ},
          {path: 'notice', name: 'notice', component: Notice},
          {path: 'about_limit', name: 'about_limit', component: AboutLimit},
          {path: 'rule', name: 'rule', component: Rule},
          {path: 'privacy', name: 'privacy', component: Privacy},
          {path: 'law', name: 'law', component: Law},
        ]},
    ]
  },
  {path: '/foo', component: Foo},
  {path: '/bar', component: Bar},
  {path: '/preview/:id', component: Preview},
  {path: '/preview/:id/:direction', component: Preview},
  {path: '/preview/:id/:index/:direction', component: Preview},
];
export default new VueRouter({
  mode: 'history',
  routes // routes: routes の短縮表記
});
